import { useLocation, useNavigate } from "react-router-dom";

const FORMULES = {
  lavage: {
    label: "Lavage Unique",
    emoji: "🫧",
    description: "Payez à chaque passage en boutique.",
    avantages: ["Accès immédiat", "Carte de fidélité incluse", "Sans engagement"],
    couleur: "blue",
  },
  abonnement: {
    label: "Abonnement Mensuel",
    emoji: "🎫",
    description: "Accès illimité chaque mois avec des avantages exclusifs.",
    avantages: ["Lavages illimités", "Priorité aux machines", "Réductions sur les services", "Carte de fidélité premium"],
    couleur: "blue",
  },
};

export default function Paiement() {
  const { state } = useLocation();
  const navigate = useNavigate();
  const type = state?.type;
  const formule = FORMULES[type];

  return (
    <div
      className="min-h-screen flex flex-col items-center justify-center px-4 py-12"
      style={{ backgroundColor: "var(--bg)" }}
    >
      {/* Logo */}
      <img
        src="/images/wash_bros_logo.png"
        alt="Wash Bros"
        className="w-28 h-28 object-contain mb-6 drop-shadow-lg"
      />

      <h1 className="text-3xl font-bold mb-2 text-center" style={{ color: "var(--text)" }}>
        Finalisez votre inscription
      </h1>
      <p className="text-center mb-8 max-w-md text-sm" style={{ color: "var(--text-muted)" }}>
        Votre formule a bien été enregistrée. Il ne vous reste plus qu'à effectuer le paiement en boutique pour activer votre accès.
      </p>

      {/* Récap formule */}
      {formule && (
        <div
          className="w-full max-w-md rounded-2xl border-2 border-blue-400 p-6 mb-8 shadow-md"
          style={{ backgroundColor: "var(--bg-card)" }}
        >
          <div className="text-4xl mb-3">{formule.emoji}</div>
          <h2 className="text-xl font-bold mb-1" style={{ color: "var(--text)" }}>
            {formule.label}
          </h2>
          <p className="text-sm mb-4" style={{ color: "var(--text-muted)" }}>
            {formule.description}
          </p>
          <ul className="text-sm space-y-1" style={{ color: "var(--text-muted)" }}>
            {formule.avantages.map((a, i) => (
              <li key={i}>✅ {a}</li>
            ))}
          </ul>
        </div>
      )}

      {/* Instructions paiement */}
      <div className="w-full max-w-md rounded-2xl bg-yellow-50 border border-yellow-200 p-6 mb-6">
        <h3 className="text-lg font-semibold text-yellow-800 mb-3">📍 Comment payer ?</h3>
        <ol className="text-sm text-yellow-700 space-y-2 list-decimal list-inside">
          <li>Rendez-vous en boutique Wash Bros.</li>
          <li>Présentez votre compte à l'accueil (nom ou email).</li>
          <li>Effectuez le paiement en caisse.</li>
          <li>Votre QR code sera activé immédiatement après confirmation.</li>
        </ol>
      </div>

      {/* Boutons */}
      <div className="w-full max-w-md space-y-3">
        <button
          onClick={() => navigate("/abonnement")}
          className="w-full py-3 rounded-xl bg-blue-600 text-white font-semibold hover:bg-blue-700 transition shadow"
        >
          Voir mon compte →
        </button>
        <button
          onClick={() => navigate("/wash-bros")}
          className="w-full py-2.5 rounded-xl bg-gray-100 text-gray-600 font-medium hover:bg-gray-200 transition text-sm"
          style={{ color: "var(--text-muted)" }}
        >
          ← Changer de formule
        </button>
      </div>

      <p className="text-xs mt-6 text-center" style={{ color: "var(--text-muted)" }}>
        Votre QR code restera verrouillé jusqu'à confirmation du paiement en boutique.
      </p>
    </div>
  );
}
